export const LABELS = {
  TITLE: "Don't forget this draft",
  EDIT: 'Edit',
  DELETE: 'Delete',
};
